const apiUrl = process.env.REACT_APP_API_URL;

export const ToggleUsuariAula = async (idAula: string | number, idUsuari: string | number, estat: number) => {
    try {
        await fetch(`${apiUrl}:8061/aules/${idAula}/alumnes/${idUsuari}/toggle?estat=${estat}`, {
            method: 'POST'
        });
    } catch (error) {
        console.error('Error toggling user:', error);
    }
};
